export default __webpack_public_path__ + "795ffaeb57d825420ec1a581de8b1817.png";